<template>
  <div class="text-no-wrap">
    <template v-if="!uuid">
      <v-icon :color="iconColor">{{ icon }}</v-icon>
    </template>
    <template v-else>
      <v-progress-circular
        v-if="['PENDING','STARTED'].includes(status)" 
        :indeterminate="!(uuid == $store.state.socket.progress.uuid)"
        :value="$store.state.socket.progress.percentage" 
        :size="size" :color="color" :width="width" 
      ></v-progress-circular>
      <v-icon v-else :color="iconColor">{{ icon }}</v-icon>
    </template>
  </div>
</template>
<script>
export default {
  name: "AxStatus",
  props: {
    uuid: { type: String, default: null },
    status: { type: String, default: null },
    size: { type: Number, default: 20 },
    color: { type: String, default: 'primary' },
    width: { type: Number, default: 2 },
  },
  computed: {
    icon() {
      if (!this.status) return 'mdi-help'
      if (['SUCCESS'].includes(this.status)) return 'mdi-check'
      if (['PENDING','STARTED'].includes(this.status)) return 'mdi-progress-clock'
      if (['REVOKED','FAILURE'].includes(this.status)) return 'mdi-alert'
    },
    iconColor() {
      if (!this.status) return 'grey'
      if (['SUCCESS'].includes(this.status)) return 'success'
      if (['PENDING','STARTED'].includes(this.status)) return 'primary'
      if (['REVOKED','FAILURE'].includes(this.status)) return 'error'
    }
  }
}
</script>